(function(){if(document.getElementById('cart-drawer-layout-fix'))return;var st=document.createElement('style');st.id='cart-drawer-layout-fix';st.textContent='cart-drawer cart-drawer-items{position:relative;z-index:0;isolation:isolate;contain:paint;transform:translateZ(0);-webkit-overflow-scrolling:touch;}cart-drawer .drawer__header,cart-drawer .free-shipping-bar,cart-drawer .drawer__footer{position:relative;z-index:2;background-color:inherit;}cart-drawer #jdgm-cart-drawer-widget{max-width:100%;overflow:hidden;}';document.head.appendChild(st);})();

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      // Cool Tea: keep shoppers on the page after adding to cart.
      // The drawer only opens if it is already open, or if data-auto-open="true" is set on <cart-drawer>.
            this.open();
    });
  }

  showAddedNotice() {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!document.getElementById('CartAddedToastStyle')) {
      const style = document.createElement('style');
      style.id = 'CartAddedToastStyle';
      style.textContent = `
        .cart-added-toast {
          position: fixed; left: 50%; bottom: calc(88px + env(safe-area-inset-bottom, 0px)); z-index: 1000;
          transform: translate(-50%, 16px); opacity: 0; pointer-events: none;
          display: flex; align-items: center; gap: 14px;
          max-width: calc(100% - 32px); padding: 8px 8px 8px 18px;
          background: #2F3A0A; color: #FFFFFF; border-radius: 999px;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
          font-size: 14px; line-height: 1.2; white-space: nowrap;
          transition: opacity 0.25s ease, transform 0.25s ease;
        }
        .cart-added-toast.is-visible { opacity: 1; transform: translate(-50%, 0); pointer-events: auto; }
        .cart-added-toast__btn {
          font: inherit; font-weight: 600; cursor: pointer;
          background: #E0EAB2; color: #2F3A0A; border: 0; border-radius: 999px; padding: 8px 14px;
        }
        .cart-added-toast__btn:hover { background: #FFFFFF; }
        #cart-icon-bubble.cart-bump { animation: coolTeaCartBump 0.5s ease; }
        @keyframes coolTeaCartBump { 0% { transform: scale(1); } 40% { transform: scale(1.25); } 100% { transform: scale(1); } }
        @media (prefers-reduced-motion: reduce) {
          .cart-added-toast { transition: none; }
          #cart-icon-bubble.cart-bump { animation: none; }
        }
      `;
      document.head.appendChild(style);
    }

    if (bubble) {
      bubble.classList.remove('cart-bump');
      void bubble.offsetWidth;
      bubble.classList.add('cart-bump');
    }

    let toast = document.getElementById('CartAddedToast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'CartAddedToast';
      toast.className = 'cart-added-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML = '<span class="cart-added-toast__text">Added to cart</span><button type="button" class="cart-added-toast__btn">View cart</button>';
      document.body.appendChild(toast);
      toast.querySelector('.cart-added-toast__btn').addEventListener('click', () => {
        toast.classList.remove('is-visible');
        this.open(bubble);
      });
    }

    toast.classList.add('is-visible');
    clearTimeout(this.addedNoticeTimer);
    this.addedNoticeTimer = setTimeout(() => toast.classList.remove('is-visible'), 3500);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);